
import Vue from "vue";
import {startMessenger} from "@/services/tawkToMessengerService";
import { Emit } from "@/api/apiHelper";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
  showInformationSnackbar,
} from "@/utils/snackbarUtils";
import camelcaseKeys from "camelcase-keys";

/**
 * 🏗
 * Base view which can be both in authenticated state and in unauthenticated state
 */
export default class BaseView extends Vue {
  protected async mounted() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = this.$store.state.authorization.authorizationToken;
    await this.isAuthorized();
  }

  /**
   * Checks whether the current user is authorized to be on this screen
   */
  private async isAuthorized() {
    try {
      let response = await Vue.prototype.$api.get(
        "/api/v1/login",
        null,
        Emit.None
      );
      let data = response.data;
      let formattedData = camelcaseKeys(data);

      if (formattedData && formattedData.isEmailValidated != undefined) {
        this.$store.dispatch(
          "changeUserEmailVerifiedFlag",
          formattedData.isEmailValidated
        );
      }

      if (formattedData && formattedData.authenticated === true) {
        this.$store.dispatch("changeAuthorizationFlag", true);
        this.$store.dispatch("changeUserCreationTime", formattedData.timeAdded);
        startMessenger({
          name: this.$store.state.userData.username,
          email: this.$store.state.userData.email,
        })
      } else {
        this.clearExistingAuthorizationToken();
        startMessenger(null);
      }
    } catch (error) {
      this.clearExistingAuthorizationToken();
      startMessenger(null);
    }
  }

  /**
   * Clears the the existing authorization token
   */
  protected clearExistingAuthorizationToken() {
    Vue.axios.defaults.headers.common["Authorization"] = "";
    this.$store.commit("SET_AUTHORIZATION_TOKEN", undefined);
  }

  /**
   * 📡 Sends an error event that will be displayed as snackbar
   * @param message - the error message that needs be shown
   */
  protected showErrorSnackbar(message: string) {
    showErrorSnackbar(message);
  }

  /**
   * 📡 Sends an information event that will be displayed as snackbar
   * @param message - the error message that needs be shown
   */
  protected showInformationSnackbar(message: string) {
    showInformationSnackbar(message);
  }

  /**
   * 📡 Sends a success event that will be displayed as snackbar
   * @param message - the success message that needs to be shown
   */
  protected showSuccessSnackbar(message: string) {
    showSuccessSnackbar(message);
  }
}
